import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosError } from 'axios';
import { envConfig } from '../../config/env';
import { useAuthStore } from '../../stores/authStore';

// Create axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: envConfig.API_BASE_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add Authorization header
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    console.log('[DEBUG] (👉ﾟヮﾟ)👉  ~ config:', config)
    const accessToken = useAuthStore.getState().accessToken;
    if (accessToken && config.headers && !config.headers['Authorization']) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors (e.g., 401)
apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      // Handle 401: token expired or invalid
      useAuthStore.getState().logout();
      // Redirect to login page
      // check current path, if valid /facility -> redirect to /login else redirect to /admin/login
      if (window.location.pathname.includes('/facility') || window.location.pathname == '/login') {
        window.location.href = '/login';
      } else {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;

